const PencilSignature = ({
  width = '24',
  height = '24',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 16.5001C16.0585 16.5001 16.5682 17.0826 16.9553 18.3743L17.0231 18.6116C17.2056 19.2688 17.3147 19.4658 17.5358 19.5569C17.7949 19.6636 17.9676 19.6485 18.2392 19.5089L18.3861 19.4265C18.439 19.3948 18.4966 19.3582 18.5617 19.3151L19.225 18.8637C19.8408 18.4586 20.3942 18.1909 21.0681 18.0224C21.4699 17.922 21.8771 18.1663 21.9776 18.5682C22.078 18.97 21.8337 19.3772 21.4319 19.4777C21.0248 19.5794 20.6737 19.7334 20.2866 19.967L19.988 20.1579L19.5089 20.4859C19.2792 20.6421 19.1057 20.75 18.925 20.8429C18.2821 21.1734 17.6552 21.2285 16.9642 20.9437C16.2194 20.6367 15.919 20.1638 15.6379 19.222L15.4821 18.6802C15.3007 18.0909 15.1771 18.0001 14.75 18.0001C14.4406 18.0001 14.1204 18.1548 13.6816 18.523L13.4969 18.6839L12.576 19.5593C11.1678 20.8829 9.96738 21.5256 8.24862 21.5256C6.56233 21.5256 5.10393 21.2716 3.87967 20.7567L6.82726 19.9525C7.27453 20.0011 7.74823 20.0256 8.24862 20.0256C9.43136 20.0256 10.2804 19.6106 11.3348 18.663L11.5931 18.4243L12.1249 17.9131C12.3615 17.6863 12.5388 17.5238 12.7174 17.374C13.401 16.8004 14.0223 16.5001 14.75 16.5001ZM19.0303 2.96973C20.4278 4.36719 20.4278 6.63293 19.0303 8.03039L18.7421 8.3191C19.8936 9.72044 19.852 11.2056 18.7811 12.2796L16.7798 14.2809C16.4867 14.5735 16.0118 14.5731 15.7192 14.2799C15.4265 13.9868 15.427 13.5119 15.7201 13.2193L17.7189 11.2205C18.2039 10.7341 18.26 10.1302 17.6791 9.38214L9.06198 17.9987C8.7851 18.2756 8.44076 18.4754 8.063 18.5784L2.94731 19.9736C2.38744 20.1263 1.87371 19.6126 2.0264 19.0527L3.42159 13.937C3.52462 13.5593 3.72444 13.2149 4.00132 12.9381L13.9696 2.96973C15.3671 1.57227 17.6328 1.57227 19.0303 2.96973Z"
        fill="url(#paint0_linear_12_10834)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12_10834"
          x1="1.99915"
          y1="1.92163"
          x2="27.0393"
          y2="19.0608"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#298EE6" />
          <stop offset="1" stopColor="#1A344D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default PencilSignature;
